module.exports = __webpack_public_path__ + "7344d23078a27cb25a781c12ab376d32.pdf";